import React, { useState } from "react";
import PageSeo from "../../components/seo/PageSeo";
import { Navigate, useParams } from "react-router-dom";
import { resetPassCall } from "../../calls";
import Error from "../../components/Error/Error";
import { useTranslation } from "react-i18next";
import "../../components/login/auth-signal.css";

/* RESET PASSWORD — design "Signal" */
const ResetPassword = (props) => {
  const {
    isLoggedIn,
    showErrorModal, setShowErrorModal, setErrorMsg, errorMsg,
    setLoader,
  } = props;
  const { t } = useTranslation();
  const { tokens, userid } = useParams();

  const [pass, setPass] = useState({ password: "", confirmPass: "" });
  const [error, setError] = useState([]);
  const [success, setSuccess] = useState("");
  const [show, setShow] = useState({ a: false, b: false });

  const handleDataChange = (e) => {
    setPass({ ...pass, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError([]);
    if (pass.password !== pass.confirmPass) {
      setError([t("signal.pw-mismatch")]);
      return;
    }
    setLoader(false);
    resetPassCall(pass, tokens, userid)
      .then(() => {
        setLoader(true);
        setSuccess(t("signal.pw-reset-ok"));
      })
      .catch((err) => {
        setLoader(true);
        const d = (err.response && err.response.data) || {};
        if (err.response && err.response.status === 404) {
          setErrorMsg([t("signal.pw-reset-invalid-link")]);
          setShowErrorModal(true);
        } else if (d.token_expire) {
          // Lien expire ou deja utilise (users/views.py : {"token_expire": "Token Expired"})
          setError([t("signal.pw-reset-invalid-link")]);
        } else if (/do not match/i.test(d.message || "")) {
          setError([t("signal.pw-mismatch")]);
        } else {
          setError([t("signal.pw-reset-failed")]);
        }
      });
  };

  if (isLoggedIn) return <Navigate replace to="/" />;

  return (
    <div className="sg-page" style={{ maxWidth: 440, minHeight: "60vh", justifyContent: "center" }}>
      <PageSeo noindex title={t("overview.reset-pass")} />
      <div className="sg-panel" style={{ padding: 24 }}>
        <h1 className="sg-h1" style={{ fontSize: 20, marginBottom: 16 }}>
          {t("overview.reset-pass")}
        </h1>
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div className="auth-field">
            <span className="auth-field__label">{t("overview.new-pass")}</span>
            <div className="auth-field__box">
              <input
                required
                value={pass.password}
                onChange={handleDataChange}
                type={show.a ? "text" : "password"}
                id="password"
                name="password"
                placeholder="••••••••"
                autoComplete="new-password"
              />
              <button type="button" className="auth-field__show" onClick={() => setShow({ ...show, a: !show.a })}>
                {show.a ? t("signal.auth-hide") : t("signal.auth-show")}
              </button>
            </div>
          </div>
          <div className="auth-field">
            <span className="auth-field__label">{t("overview.confirm-pass")}</span>
            <div className="auth-field__box">
              <input
                required
                value={pass.confirmPass}
                onChange={handleDataChange}
                type={show.b ? "text" : "password"}
                id="confirmPass"
                name="confirmPass"
                placeholder="••••••••"
                autoComplete="new-password"
              />
              <button type="button" className="auth-field__show" onClick={() => setShow({ ...show, b: !show.b })}>
                {show.b ? t("signal.auth-hide") : t("signal.auth-show")}
              </button>
            </div>
          </div>
          {error.map((e, i) => (
            <p key={i} className="auth-card__error">{e}</p>
          ))}
          {success && (
            <p className="sg-status sg-status--ok" style={{ fontSize: 13 }}>{success}</p>
          )}
          <button type="submit" className="sg-btn sg-btn--primary" style={{ width: "100%" }}>
            {t("overview.reset-pass")}
          </button>
        </form>
      </div>
      <Error
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
        errorMsg={errorMsg}
      />
    </div>
  );
};

export default ResetPassword;
